// extracted by mini-css-extract-plugin
module.exports = {"chatItem":"ChatSkeleton_chatItem__3mSjN","avatar":"ChatSkeleton_avatar__2IIKB","loadingIcon":"ChatSkeleton_loadingIcon__NwEaX"};